import { render } from "./Modal.vue?vue&type=template&id=4d4d7bc3"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=4d4d7bc3&lang=css"

import exportComponent from "D:\\Projects\\Breednet\\breednet-frontend\\breednet-blackbook-frontend-master\\Components\\add-horse-btn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__